// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7407) return "static/chunks/7407-d60defb6b3f7ae95.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3265":"e30f25e5387a2eec","6920":"71dd5e2eddd0b162"}[chunkId] + ".js";
};